const elementId: Record<string, number> = {
  playerOff: 120000,
  playerOn: 130000,
};

export default elementId;
